// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error[data-v-061be444]{padding:8rem;text-align:center}.text[data-v-061be444]{padding:6rem 0}.link[data-v-061be444]{-webkit-text-fill-color:transparent;background:-webkit-linear-gradient(#815ef6,#4b4ef0);background-clip:text;-webkit-background-clip:text}@media screen and (max-width:500px){.error[data-v-061be444]{padding:2rem 0}.text[data-v-061be444]{padding:2rem 0 3rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
